import { gql } from 'graphql-tag';
export const standardsPerformanceByPrograms = gql `
    query standardsPerformanceByPrograms($districtIds: [String!]!) {
        standardsPerformanceByPrograms(districtIds: $districtIds) {
            standardsPerformanceByPrograms {
                programName
                totalStandardsAssessed
                percentageOfStandardsMastered
                percentageOfStandardsNotMastered
                totalStandardsMastered
                totalStandardsNotMastered
            }
        }
    }
`;
